<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Обновление проекта</template>
        <template v-slot:content>
            <v-form class = 'px-4' v-model = 'valid'>
                <v-text-field v-model = "project.project_name" label="Название проекта" :rules = "[rules.required]"></v-text-field>
                <v-textarea v-model = "project.description" label="Описание проекта" :rules = "[rules.required]"></v-textarea>
                <v-select
                    disabled
                    v-model = "project.segment_id" 
                    :items = 'projectSegments' 
                    item-value = 'segment_id' 
                    item-text = 'segment_name'
                    label="Сегмент" :rules = "[rules.required]"
                ></v-select>
                <v-select
                    v-model = "project.vertical_id" 
                    :items = 'projectVerticals' 
                    item-value = 'vertical_id' 
                    item-text = 'vertical_name'
                    label="Вертикаль" :rules = "[rules.required]"
                ></v-select>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :disabled = '!valid' :loading = 'indicator' block depressed @click = 'updateProject'>Применить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
    import projectHandlers from '@/mixins/project'

    export default {
        name: 'ProjectUpdateDialog',
        props: ['data', 'initialState'],
        mixins: [projectHandlers],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                project: this.data,
                indicator: false,
                valid: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            data(value) {
                this.project = value
            }
        },
        computed: {
            projectSegments() {
                return this.$store.state.segments
            },
            projectVerticals() {
                return this.$store.state.verticals
            }
        },
        methods: {
            updateProject() {
                this.indicator = true;
                this.updateProjectPromise().then((r) => {
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'update',
                            target: 'project'
                        },
                        once: false
                    })
                    this.$store.dispatch('authorizeUser', { flow: 'resume', user: { persistance: true } })
                    this.visibility = false;
                    this.indicator = false;
                });
            }
        },
        mounted() {
            this.$store.dispatch('fillSegments');
            this.$store.dispatch('fillVerticals');
        }
    }
</script>